import {
  SHOW_REQUEST_REASON,
  SHOW_ADD_REQUEST_REASON,
  GET_BRANCH_DETAILS,
  GET_ITEM_DETAILS,
  GET_VEHICLE_DETAILS,
  GET_VALID_ASSET_DATA_PLANNED,
  SET_VALID_ASSET_DATA_PLANNED,
  SET_ASSET_VALIDATION_PLANNED_FLG,
  SET_AUTO_COMPLETE_ASSET_PLANNED,
  GET_AUTO_COMPLETE_ASSET_PLANNED,
  GET_CATALOG_ITEM_DETAILS,
  SET_CATALOG_ITEM_DETAILS,
  GET_VEHICLE_TYPE_DROPDOWN,
  SET_VEHICLE_TYPE_DROPDOWN,
  SET_VEHICLE_TYPE_ID,
  SET_SELECTED_BRANCH_DETAILS,
  SET_SELECTED_VEHICLE_TYPE,
  SET_ORDER,
  GET_PREFERRED_MODEL_DROPDOWN,
  SET_PREFERRED_MODEL_DROPDOWN,
  SET_ITEM_DETAILS_GROWTH,
  SET_REASON_TYPES,
  GET_REASON_TYPES,
  SET_REASON_INFO,
  SET_ADD_CLICK_FLG,
  GET_BRANCH,
  SET_BRANCH,
  SHOW_CATALOG_ITEM_DETAILS,
  SET_SELECTED_VEHICLES_COUNT,
  GET_ADD_ORDER,
  SET_ADD_ORDER,
  SET_FILTERED_CATALOG_ITEM_VALUES,
  SET_CREATE_ORDER_COMPLETE_FLAG,
  GET_UPLOADED_BLOB_URL_LIST,
  SET_UPLOADED_BLOB_URL_LIST,
  SET_UPLOAD_FILES_COMPLETE,
  GET_ASSET_TYPES,
  SET_ASSET_TYPES,
  SET_SPLICE_FLAG,
  GET_EQUIPMENT_DROPDOWN,
  SET_EQUIPMENT_DROPDOWN,
  GET_SEATINGCAPACITY_DROPDOWN,
  SET_SEATINGCAPACITY_DROPDOWN,
  GET_UTILITYMANUFACTURE_DROPDOWN,
  SET_UTILITYMANUFACTURE_DROPDOWN,
  GET_UTILITYCAPACITY_DROPDOWN,
  SET_UTILITYCAPACITY_DROPDOWN,
  GET_UTILITYENCLOSEDCAB_DROPDOWN,
  SET_UTILITYENCLOSEDCAB_DROPDOWN,
  GET_TRAILERMANUFACTURE_DROPDOWN,
  SET_TRAILERMANUFACTURE_DROPDOWN,
  GET_TRAILERSTYLE_DROPDOWN,
  SET_TRAILERSTYLE_DROPDOWN,
  GET_TRAILERLENGTH_DROPDOWN,
  SET_TRAILERLENGTH_DROPDOWN,
  GET_TRAILERFUELTANK_DROPDOWN,
  SET_TRAILERFUELTANK_DROPDOWN,
  GET_TRAILERCHARGINGSTATION_DROPDOWN,
  SET_TRAILERCHARGINGSTATION_DROPDOWN,
  GET_SNOWMANUFACTURE_DROPDOWN,
  SET_SNOWMANUFACTURE_DROPDOWN,
  GET_SNOWCATEGORY_DROPDOWN,
  SET_SNOWCATEGORY_DROPDOWN,
  GET_SNOWTYPE_DROPDOWN,
  SET_SNOWTYPE_DROPDOWN,
  GET_SNOWSIZE_DROPDOWN,
  SET_SNOWSIZE_DROPDOWN,
  GET_SNOWPARENTVEHICLE_DROPDOWN,
  GET_DEVELOPMENTCATEGORY_DROPDOWN,
  SET_DEVELOPMENTCATEGORY_DROPDOWN,
  GET_DEVELOPMENTMANUFACTURE_DROPDOWN,
  SET_DEVELOPMENTMANUFACTURE_DROPDOWN,
  GET_TREEMANUFACTURE_DROPDOWN,
  SET_TREEMANUFACTURE_DROPDOWN,
  GET_TREEEQUIPMENTTYPE_DROPDOWN,
  SET_TREEEQUIPMENTTYPE_DROPDOWN,
  GET_TREEHORSEPOWER_DROPDOWN,
  SET_TREEHORSEPOWER_DROPDOWN,
  GET_TREEFUELTYPE_DROPDOWN,
  SET_TREEFUELTYPE_DROPDOWN,
  GET_STANDARDCATEGORY_DROPDOWN,
  SET_STANDARDCATEGORY_DROPDOWN,
  GET_STANDARDMANUFACTURE_DROPDOWN,
  SET_STANDARDMANUFACTURE_DROPDOWN,
  SET_VEHICLETYPE_FLAG,
  SET_VEHICLE_HISTORY_CARD_FLAG,
  SET_SELECT_FLAG,
  SET_UPLOADED_ATTACHMENT_DETAILS,
  GET_STATE_AVAILABILITY,
  SET_STATE_AVAILABILITY,
  GET_PROGRAM_STATUS,
  SET_PROGRAM_STATUS,
  SET_ANNUAL_HOURS,
  GET_ANNUAL_HOURS,
  GET_DECK_TYPE,
  SET_DECK_TYPE,
  GET_DECK_SIZES,
  SET_DECK_SIZES,
  GET_AUTONOMOUS,
  SET_AUTONOMOUS,
  GET_MANUFACTURER_DROPDOWN,
  SET_MANUFACTURER_DROPDOWN,
  GET_CATEGORY_DROPDOWN,
  SET_CATEGORY_DROPDOWN,
  SET_EDIT_CLICK_FLG,
  GET_EDIT_VEHICLE_INDEX,
  SET_EDIT_VEHICLE_INDEX,
  SET_SEARCH_ERROR,
  SET_ASSET_TYPE_ID,
  SET_ASSET_TYPE_TEXT,
  SET_EDIT_REASON_VALUE,
  SET_CART_NAV,
  SET_HEADER_NAV,
  SET_IS_SAVE,
  SET_ORDER_ID,
  SET_ACTIVE_HEADER,
  SET_CLICK_PREVIOUS,
  SET_GRAND_TOTAL,
  GET_REASONCONDITION_DROPDOWN,
  GET_REASONSTATUS_DROPDOWN,
  SET_REASONCONDITION_DROPDOWN,
  SET_REASONSTATUS_DROPDOWN,
  GET_DROPDOWNS_BY_SUBTYPE,
  SET_DROPDOWNS_BY_SUBTYPE,
  APPEND_DROPDOWN_DATA,
  SET_BRANCH_CHANGE_FLAG,
  SET_ADD_REASON_FLAG,
  SET_CATALOG_ACTIVE_STEPPER_FLAG,
  REQUEST_COST_CENTER,
  SUCCESS_COST_CENTER,
  SET_SELECTED_REASON_TYPE,
  SET_IS_REFRESH_REASON
} from "./types";
export const setCartNav = (value: any) => {
  return {
    type: SET_CART_NAV,
    payload: value,
  };
};
export const setActiveHeader = (setActiveHeader: any) => {
  return {
    type: SET_ACTIVE_HEADER,
    payload: setActiveHeader,
  };
};
export const setClickPrevious = (setClickPrevious: any) => {
  return {
    type: SET_CLICK_PREVIOUS,
    payload: setClickPrevious,
  };
};
export const RequestReason = (RequestReason: any) => {
  return {
    type: SHOW_REQUEST_REASON,
    payload: RequestReason,
  };
};

export const AddRequestReason = (AddRequestReason: any) => {
  return {
    type: SHOW_ADD_REQUEST_REASON,
    payload: AddRequestReason,
  };
};

export const BranchDetails = (BranchDetails: any) => {
  return {
    type: GET_BRANCH_DETAILS,
    payload: BranchDetails,
  };
};

export const ItemDetails = (ItemDetails: any) => {
  return {
    type: GET_ITEM_DETAILS,
    payload: ItemDetails,
  };
};

export const VehicleDetails = (VehicleDetails: any) => {
  return {
    type: GET_VEHICLE_DETAILS,
    payload: VehicleDetails,
  };
};
export const GetVehicleTypeDropdown = (assetTypeId: number) => {
  return {
    type: GET_VEHICLE_TYPE_DROPDOWN,
    assetTypeId,
  };
};
export const SetVehicleTypeDropdown = (vehilesTypeDropdown: any) => {
  return {
    type: SET_VEHICLE_TYPE_DROPDOWN,
    payload: vehilesTypeDropdown,
  };
};


export const getValidAssetDetailsPlanned = (assetId: any) => {
  return {
    type: GET_VALID_ASSET_DATA_PLANNED,
    assetId,
  };
};

export const setValidAssetDetailsPlanned = (validAssetDetailsPlanned: any) => {
  return {
    type: SET_VALID_ASSET_DATA_PLANNED,
    validAssetDetailsPlanned,
  };
};

export const setAssetValidationPlannedFlag = (
  assetValidationPlannedFlag: boolean
) => {
  return {
    type: SET_ASSET_VALIDATION_PLANNED_FLG,
    assetValidationPlannedFlag,
  };
};

export const getAutoCompleteAssetPlanned = (assetId: any) => {
  return {
    type: GET_AUTO_COMPLETE_ASSET_PLANNED,
    assetId,
  };
};

export const setAutoCompleteAssetPlanned = (autoCompleteAssetPlanned: any) => {
  return {
    type: SET_AUTO_COMPLETE_ASSET_PLANNED,
    autoCompleteAssetPlanned,
  };
};

export const GetPreferredModelDropdown = (assertMakeId: number) => {
  return {
    type: GET_PREFERRED_MODEL_DROPDOWN,
    assertMakeId,
  };
};
export const SetPreferredModelDropdown = (preferredModelDropdown: any) => {
  return {
    type: SET_PREFERRED_MODEL_DROPDOWN,
    payload: preferredModelDropdown,
  };
};

export const getCatalogItemDetails = (catalogRequestBody: {}, fleetRequestDetailId?: number | null) => {
  return {
    type: GET_CATALOG_ITEM_DETAILS,
    catalogRequestBody,
    fleetRequestDetailId,
  };
};

export const setCatalogItemDetails = (
  catalogDetails: any,
  noRecordsMessage: string,
  fleetRequestDetailId?: number | null
) => {
  return {
    type: SET_CATALOG_ITEM_DETAILS,
    catalogDetails,
    noRecordsMessage,
    fleetRequestDetailId,
  };
};

export const setVehicleTypeId = (setVehicleTypeId: any) => {
  return {
    type: SET_VEHICLE_TYPE_ID,
    payload: setVehicleTypeId,
  };
};

export const setSelectedBranchDetails = (selectedBranchDetails: any) => {
  return {
    type: SET_SELECTED_BRANCH_DETAILS,
    selectedBranchDetails: selectedBranchDetails,
  };
};

export const setSelectedVehicleType = (selectedVehicleType: any) => {
  return {
    type: SET_SELECTED_VEHICLE_TYPE,
    selectedVehicleType: selectedVehicleType,
  };
};

export const setOrderDetails = (orderDetails: any) => {
  return {
    type: SET_ORDER,
    orderDetails,
  };
};

export const setReasonTypes = (value: any) => {
  return {
    type: SET_REASON_TYPES,
    value,
  };
};

export const getReasonTypes = () => {
  return {
    type: GET_REASON_TYPES,
  };
};
export const setItemDetailsGrowth = (value: any) => {
  return {
    type: SET_ITEM_DETAILS_GROWTH,
    value,
  };
};

export const setReasonInfo = (reasonInfo: any) => {
  return {
    type: SET_REASON_INFO,
    reasonInfo,
  };
};

export const setAddClickFlg = (addClickFlg: any) => {
  return {
    type: SET_ADD_CLICK_FLG,
    addClickFlg,
  };
};

export const GetBranch = (user: any) => {
  return {
    type: GET_BRANCH,
    user,
  };
};

export const SetBranch = (BranchList: any) => {
  return {
    type: SET_BRANCH,
    payload: BranchList,
  };
};

export const showCatalogItemDetails = (val: boolean) => {
  return {
    type: SHOW_CATALOG_ITEM_DETAILS,
    payload: val,
  };
};

export const setSelectedVehiclesCount = (count: number) => {
  return {
    type: SET_SELECTED_VEHICLES_COUNT,
    payload: count,
  };
};

export const GetAddOrder = (order: any) => {
  return {
    type: GET_ADD_ORDER,
    order,
  };
};
export const SetAddOrder = (OrderResponse: any) => {
  return {
    type: SET_ADD_ORDER,
    payload: OrderResponse,
  };
};

export const setFilteredCatalogItemValues = (
  filteredCatalogItemValues: any
) => {
  return {
    type: SET_FILTERED_CATALOG_ITEM_VALUES,
    filteredCatalogItemValues,
  };
};

export const setCreateOrderCompleteFlg = (isCreateOrderComplete: any) => {
  return {
    type: SET_CREATE_ORDER_COMPLETE_FLAG,
    isCreateOrderComplete,
  };
};

export const getUploadedBlobUrlList = (fileObj: any) => {
  return {
    type: GET_UPLOADED_BLOB_URL_LIST,
    fileObj,
  };
};

export const setUploadedBlobUrlList = (BlobUrlListObj: any) => {
  return {
    type: SET_UPLOADED_BLOB_URL_LIST,
    BlobUrlListObj,
  };
};

export const setUploadFilesComplete = (isUploadComplete: any) => {
  return {
    type: SET_UPLOAD_FILES_COMPLETE,
    isUploadComplete,
  };
};

export const getAssestTypes = () => {
  return {
    type: GET_ASSET_TYPES,
  };
};

export const setAssestTypes = (value: any) => {
  return {
    type: SET_ASSET_TYPES,
    payload: value,
  };
};

export const setSpliceFlag = (isSpliceFlag: boolean) => {
  return {
    type: SET_SPLICE_FLAG,
    payload: isSpliceFlag,
  };
};

export const setIsRefreshReason = (isRefreshReason: boolean) => {
  return {
    type: SET_IS_REFRESH_REASON,
    payload: isRefreshReason,
  };
};

export const setcatalogActiveStepperFlag = (isCatalogActiveStepper: boolean) => {
  return {
    type: SET_CATALOG_ACTIVE_STEPPER_FLAG,
    payload: isCatalogActiveStepper,
  };
};

export const getEquipmentDropdown = (assetSubTypeId: number) => {
  return {
    type: GET_EQUIPMENT_DROPDOWN,
    assetSubTypeId,
  };
};

export const setEquipmentDropdown = (equipmentDropDown: any) => {
  return {
    type: SET_EQUIPMENT_DROPDOWN,
    payload: equipmentDropDown,
  };
};

export const getSeatingCapacityDropdown = () => {
  return {
    type: GET_SEATINGCAPACITY_DROPDOWN,
  };
};

export const setSeatingCapacityDropdown = (seatingCapacityDropDown: any) => {
  return {
    type: SET_SEATINGCAPACITY_DROPDOWN,
    seatingCapacityDropDown,
  };
};

export const getUtilityManufactureDropdown = (assetSubTypeId: number) => {
  return {
    type: GET_UTILITYMANUFACTURE_DROPDOWN,
    assetSubTypeId,
  };
};

export const setUtilityManufactureDropdown = (
  utilityManufactureDropDown: any
) => {
  return {
    type: SET_UTILITYMANUFACTURE_DROPDOWN,
    payload: utilityManufactureDropDown,
  };
};

export const getUtilityEnclosedcabDropdown = () => {
  return {
    type: GET_UTILITYENCLOSEDCAB_DROPDOWN,
  };
};

export const setUtilityEnclosedcabDropdown = (
  UtilityEnclosedcabDropDown: any
) => {
  return {
    type: SET_UTILITYENCLOSEDCAB_DROPDOWN,
    UtilityEnclosedcabDropDown,
  };
};

export const getUtilityCapacityDropdown = () => {
  return {
    type: GET_UTILITYCAPACITY_DROPDOWN,
  };
};

export const setUtilityCapacityDropdown = (utilityCapacityDropDown: any) => {
  return {
    type: SET_UTILITYCAPACITY_DROPDOWN,
    utilityCapacityDropDown,
  };
};

export const getTrailerManufactureDropdown = (assetSubTypeId: number) => {
  return {
    type: GET_TRAILERMANUFACTURE_DROPDOWN,
    assetSubTypeId,
  };
};

export const setTrailerManufactureDropdown = (
  trailermanufactureDropDown: any
) => {
  return {
    type: SET_TRAILERMANUFACTURE_DROPDOWN,
    payload: trailermanufactureDropDown,
  };
};

export const getTrailerStyleDropdown = () => {
  return {
    type: GET_TRAILERSTYLE_DROPDOWN,
  };
};

export const setTrailerStyleDropdown = (trailerStyleDropDown: any) => {
  return {
    type: SET_TRAILERSTYLE_DROPDOWN,
    trailerStyleDropDown,
  };
};

export const getTrailerLengthDropdown = () => {
  return {
    type: GET_TRAILERLENGTH_DROPDOWN,
  };
};

export const setTrailerLengthDropdown = (trailerLengthDropDown: any) => {
  return {
    type: SET_TRAILERLENGTH_DROPDOWN,
    trailerLengthDropDown,
  };
};

export const getTrailerFuelTankDropdown = () => {
  return {
    type: GET_TRAILERFUELTANK_DROPDOWN,
  };
};

export const setTrailerFuelTankDropdown = (trailerFuelTankDropDown: any) => {
  return {
    type: SET_TRAILERFUELTANK_DROPDOWN,
    trailerFuelTankDropDown,
  };
};

export const getTrailerChargingstationDropdown = () => {
  return {
    type: GET_TRAILERCHARGINGSTATION_DROPDOWN,
  };
};

export const setTrailerChargingStationDropdown = (
  trailerChargingStationDropDown: any
) => {
  return {
    type: SET_TRAILERCHARGINGSTATION_DROPDOWN,
    trailerChargingStationDropDown,
  };
};

export const getSnowManufactureDropdown = (assetSubTypeId: number) => {
  return {
    type: GET_SNOWMANUFACTURE_DROPDOWN,
    assetSubTypeId,
  };
};

export const setSnowManufactureDropdown = (snowManufactureDropDown: any) => {
  return {
    type: SET_SNOWMANUFACTURE_DROPDOWN,
    payload: snowManufactureDropDown,
  };
};

export const getSnowCategoryDropdown = (assetSubTypeId: number) => {
  return {
    type: GET_SNOWCATEGORY_DROPDOWN,
    assetSubTypeId,
  };
};

export const setSnowCategoryDropdown = (snowCategoryDropDown: any) => {
  return {
    type: SET_SNOWCATEGORY_DROPDOWN,
    payload: snowCategoryDropDown,
  };
};

export const getSnowSizeDropdown = () => {
  return {
    type: GET_SNOWSIZE_DROPDOWN,
  };
};

export const setSnowSizeDropdown = (snowSizeDropDown: any) => {
  return {
    type: SET_SNOWSIZE_DROPDOWN,
    snowSizeDropDown,
  };
};
export const getSnowTypeDropdown = () => {
  return {
    type: GET_SNOWTYPE_DROPDOWN,
  };
};

export const setSnowTypeDropdown = (snowTypeDropDown: any) => {
  return {
    type: SET_SNOWTYPE_DROPDOWN,
    snowTypeDropDown,
  };
};

export const getSnowParentVehicleDropdown = () => {
  return {
    type: GET_SNOWPARENTVEHICLE_DROPDOWN,
  };
};

export const getDevelopmentCategoryDropdown = (assetSubTypeId: number) => {
  return {
    type: GET_DEVELOPMENTCATEGORY_DROPDOWN,
    assetSubTypeId,
  };
};

export const setDevelopmentCategoryDropdown = (
  developmentCategoryDropDown: any
) => {
  return {
    type: SET_DEVELOPMENTCATEGORY_DROPDOWN,
    payload: developmentCategoryDropDown,
  };
};

export const getDevelopmentManufactureDropdown = (assetSubTypeId: number) => {
  return {
    type: GET_DEVELOPMENTMANUFACTURE_DROPDOWN,
    assetSubTypeId,
  };
};

export const setDevelopmentManufactureDropdown = (
  developmentManufactureDropDown: any
) => {
  return {
    type: SET_DEVELOPMENTMANUFACTURE_DROPDOWN,
    payload: developmentManufactureDropDown,
  };
};

export const getTreeManufactureDropdown = (assetSubTypeId: number) => {
  return {
    type: GET_TREEMANUFACTURE_DROPDOWN,
    assetSubTypeId,
  };
};

export const setTreeManufactureDropdown = (TreeManufactureDropDown: any) => {
  return {
    type: SET_TREEMANUFACTURE_DROPDOWN,
    payload: TreeManufactureDropDown,
  };
};

export const getTreeEquipmentDropdown = () => {
  return {
    type: GET_TREEEQUIPMENTTYPE_DROPDOWN,
  };
};

export const setTreeEquipmentDropdown = (TreeEquipmentDropDown: any) => {
  return {
    type: SET_TREEEQUIPMENTTYPE_DROPDOWN,
    TreeEquipmentDropDown,
  };
};

export const getTreeHorsePowerDropdown = () => {
  return {
    type: GET_TREEHORSEPOWER_DROPDOWN,
  };
};

export const setTreeHorsePowerDropdown = (TreeHorsePowerDropDown: any) => {
  return {
    type: SET_TREEHORSEPOWER_DROPDOWN,
    TreeHorsePowerDropDown,
  };
};

export const getTreeFuelTypeDropdown = () => {
  return {
    type: GET_TREEFUELTYPE_DROPDOWN,
  };
};

export const setTreeFuelTypeDropdown = (TreeFuelTypeDropDown: any) => {
  return {
    type: SET_TREEFUELTYPE_DROPDOWN,
    TreeFuelTypeDropDown,
  };
};

export const getStandardManufactureDropdown = (assetSubTypeId: number) => {
  return {
    type: GET_STANDARDMANUFACTURE_DROPDOWN,
    assetSubTypeId,
  };
};

export const setStandardManufactureDropdown = (
  standardManufactureDropdown: any
) => {
  return {
    type: SET_STANDARDMANUFACTURE_DROPDOWN,
    payload: standardManufactureDropdown,
  };
};

export const getStandardCategoryDropdown = (assetSubTypeId: number) => {
  return {
    type: GET_STANDARDCATEGORY_DROPDOWN,
    assetSubTypeId,
  };
};

export const setStandardCategoryDropdown = (standardcategoryDropdown: any) => {
  return {
    type: SET_STANDARDCATEGORY_DROPDOWN,
    payload: standardcategoryDropdown,
  };
};
export const setVehicleTypeFlag = (isVehicleTypeFlag: boolean) => {
  return {
    type: SET_VEHICLETYPE_FLAG,
    payload: isVehicleTypeFlag,
  };
};

export const setVehicleHistoryCardFlag = (
  setVehicleHistoryCardFlag: boolean
) => {
  return {
    type: SET_VEHICLE_HISTORY_CARD_FLAG,
    payload: setVehicleHistoryCardFlag,
  };
};

export const setSelectFlag = (isSelectFlag: boolean) => {
  return {
    type: SET_SELECT_FLAG,
    payload: isSelectFlag,
  };
};

export const setUploadedAttachmentDetails = (
  uploadedAttachmentDetails: boolean
) => {
  return {
    type: SET_UPLOADED_ATTACHMENT_DETAILS,
    uploadedAttachmentDetails,
  };
};

export const setStateAvailability = (value: any) => {
  return {
    type: SET_STATE_AVAILABILITY,
    value,
  };
};

export const getStateAvailability = () => {
  return {
    type: GET_STATE_AVAILABILITY,
  };
};
export const setProgramStatus = (value: any) => {
  return {
    type: SET_PROGRAM_STATUS,
    value,
  };
};
export const getProgramStatus = () => {
  return {
    type: GET_PROGRAM_STATUS,
  };
};
export const setAnnualHours = (value: any) => {
  return {
    type: SET_ANNUAL_HOURS,
    value,
  };
};
export const getAnnualHours = () => {
  return {
    type: GET_ANNUAL_HOURS,
  };
};
export const setDeckType = (value: any) => {
  return {
    type: SET_DECK_TYPE,
    value,
  };
};
export const getDeckType = () => {
  return {
    type: GET_DECK_TYPE,
  };
};
export const setDeckSize = (value: any) => {
  return {
    type: SET_DECK_SIZES,
    value,
  };
};
export const getDeckSize = () => {
  return {
    type: GET_DECK_SIZES,
  };
};
export const setAutonomous = (value: any) => {
  return {
    type: SET_AUTONOMOUS,
    value,
  };
};
export const getAutonomous = () => {
  return {
    type: GET_AUTONOMOUS,
  };
};
export const getManufacturerDropDown = (assetSubTypeId: number) => {
  return {
    type: GET_MANUFACTURER_DROPDOWN,
    assetSubTypeId,
  };
};

export const setManufacturerDropdown = (manufacturerDropDown: any) => {
  return {
    type: SET_MANUFACTURER_DROPDOWN,
    payload: manufacturerDropDown,
  };
};
export const getCategoryDropDown = (assetSubTypeId: number) => {
  return {
    type: GET_CATEGORY_DROPDOWN,
    assetSubTypeId,
  };
};
export const setCategoryDropDown = (categoryDropDown: any) => {
  return {
    type: SET_CATEGORY_DROPDOWN,
    payload: categoryDropDown,
  };
};
export const setEditClickFlg = (editClickFlg: any) => {
  return {
    type: SET_EDIT_CLICK_FLG,
    editClickFlg,
  };
};

export const setEditVehicleIndex = (editVehicleIndex: number) => {
  return {
    type: SET_EDIT_VEHICLE_INDEX,
    editVehicleIndex,
  };
};
export const getEditVehicleIndex = () => {
  return {
    type: GET_EDIT_VEHICLE_INDEX,
  };
};
export const setEditReasonValue = (editReasonValues: any) => {
  return {
    type: SET_EDIT_REASON_VALUE,
    editReasonValues,
  };
};

export const setSearchError = (isSearchError: boolean) => {
  return {
    type: SET_SEARCH_ERROR,
    payload: isSearchError,
  };
};
export const setAssetTypeId = (assetTypeId: number) => {
  return {
    type: SET_ASSET_TYPE_ID,
    payload: assetTypeId,
  };
};
export const setAssetTypeText = (assetTypeText: any) => {
  return {
    type: SET_ASSET_TYPE_TEXT,
    payload: assetTypeText,
  };
};
export const setHeaderNav = (isHeaderNav: boolean) => {
  return {
    type: SET_HEADER_NAV,
    payload: isHeaderNav,
  };
};

export const setIsSaved = (status: string) => {
  return {
    type: SET_IS_SAVE,
    payload: status,
  };
};
export const setOrderId = (orderId: any) => {
  return {
    type: SET_ORDER_ID,
    payload: orderId,
  };
};
export const setGrandTotal = (grandTotal: any) => {
  return {
    type: SET_GRAND_TOTAL,
    payload: grandTotal,
  };
};
export const getReasonStatusDropdown = () => {
  return {
    type: GET_REASONSTATUS_DROPDOWN,
  };
};

export const setReasonStatusDropdown = (statusvalue: any) => {
  return {
    type: SET_REASONSTATUS_DROPDOWN,
    statusvalue,
  };
};
export const getReasonConditionDropdown = () => {
  return {
    type: GET_REASONCONDITION_DROPDOWN,
  };
};

export const setReasonConditionDropdown = (conditionValue: any) => {
  return {
    type: SET_REASONCONDITION_DROPDOWN,
    conditionValue,
  };
};

export const getDropdownsBySubType = (subTypeId: any) => ({
  type: GET_DROPDOWNS_BY_SUBTYPE,
  payload: subTypeId,
});

export const setDropdownsBySubType = (data: any) => ({
  type: SET_DROPDOWNS_BY_SUBTYPE,
  payload: data,
});

export const appendDropdownData = (data: any) => ({
  type: APPEND_DROPDOWN_DATA,
  payload: data,
});

export const setBranchChangeFlag = (isBranchChangeFlag: boolean) => {
  return {
    type: SET_BRANCH_CHANGE_FLAG,
    payload: isBranchChangeFlag,
  };
};

export const setAddReasonFlag = (addReasonFlag: boolean) => {
  return {
    type: SET_ADD_REASON_FLAG,
    payload: addReasonFlag
  };
};

export const requestCostCenters = (id?: string) => ({
  type: REQUEST_COST_CENTER,
  payload: id
});

export const successCostCenters = (costCenters: Array<any>) => ({
  type: SUCCESS_COST_CENTER,
  payload: costCenters
});

export const setSelectedReasonType = (selectedReasonType: any) =>{
  return{
    type : SET_SELECTED_REASON_TYPE,
    payload: selectedReasonType
  }
}